import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { PopupimmudbcontentComponent } from '../popupimmudbcontent/popupimmudbcontent.component';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  showLoader: boolean = false

  constructor(private _snackBar: MatSnackBar, private router: Router, private commonServ: CommonService, private http: HttpClient, private sanitizer: DomSanitizer, private modalService: NgbModal, public dialog: MatDialog) { }

  ngOnInit(): void {
    console.log('home');
    this.getDocumentType()
  }

  tabList: Array<string> = []
  // ['Definition', 'Notices', 'General T&c', 'Privacy Policy', 'Scope of Service', 'Use Terms']
  documentsList: Array<Object> = [
    // {
    //   header: 'TCS Enterprise Manager',
    //   version: '1.0',
    //   date: Date.now()
    // },
    // {
    //   header: 'TCS Enterprise Manager 2',
    //   version: '2.0',
    //   date: Date()
    // }
  ]

  getDocumentType() {
    this.commonServ.fetchDocumentType().subscribe(
      (res) => {
        console.log("res", res)
        res.forEach((element) => {
          this.tabList.push(element.lookup_code)
        });
        this.tabList.sort((a, b) => a.localeCompare(b));
      }, (err) => {
        console.log(err);
      }
    )
  }


  viewdata(n) {
    console.log(n)
    this.showLoader = true
    const dialogRef = this.dialog.open(PopupimmudbcontentComponent, {
      width: '100%',
      // data: params,
      disableClose: true,
      data: {
        header: '',
        alldata: n,
        doc_id: n['doc_id']
      },
      panelClass: 'my-dialog',
    });
    this.showLoader = false;
  }

  downloaddata(n) {
    console.log(n)
    this.commonServ.downloadpdffile(n['doc_id']).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = n['doc_name'];
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
    })
  }

  downloaddata2(n) {
    console.log(n)
    this.showLoader = true
    this.commonServ.downloadpdffile2(n['doc_id']).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      // const blob = new Blob([response[0].doc_contenet
      // ], { type: 'application/octet-stream' });
      // var link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = "testing.pdf";
      //   link.click();
      // const base64String = '...';  // Your base64-encoded PDF string
      const filename = n['doc_name'];
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
      this.showLoader = false;
    })
  }

  getDocumentsListFromCategory(event) {
    console.log("x", event.tab.textLabel);
    this.commonServ.getDocumentsListFromCategory(event.tab.textLabel).subscribe(
      (res) => {
        console.log(res);
        this.documentsList = res
      }, (err) => {
        console.log(err);
      }
    )
  }





}